import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Separator } from "@/components/ui/separator";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

export interface SectionedMenuItem {
  icon?: ReactNode;
  label: string;
  onClick?: () => void;
  active?: boolean;
  destructive?: boolean;
}

export interface SectionedMenuSection {
  label: string;
  items: SectionedMenuItem[];
}

interface SectionedMenuContentProps {
  title?: string;
  sections: SectionedMenuSection[];
  className?: string;
}

export function SectionedMenuContent({
  title,
  sections,
  className,
}: SectionedMenuContentProps) {
  return (
    <div className={cn("flex flex-col", className)}>
      {title && (
        <>
          <div className="px-3 py-3">
            <p className="text-xl font-medium leading-5">{title}</p>
          </div>
          <Separator />
        </>
      )}
      {sections.map((section) => (
        <div key={section.label} className="flex flex-col gap-2 p-3">
          <p className="text-sm text-muted-foreground">{section.label}</p>
          <div className="flex flex-col">
            {section.items.map((item) => (
              <DropdownMenuItem
                key={item.label}
                onClick={item.onClick}
                className={cn(
                  "h-10 gap-2 rounded-md px-2 text-sm",
                  item.active && "bg-accent",
                  item.destructive && "text-destructive focus:text-destructive",
                )}
              >
                {item.icon && (
                  <span className="flex size-5 shrink-0 items-center justify-center">
                    {item.icon}
                  </span>
                )}
                {item.label}
              </DropdownMenuItem>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
